const domainImages: Record<string, string> = {
  booking: 'salons', 'service-marketplaces': 'home-cleaning', 'fleet-operations': 'delivery-companies',
  'online-consultations': 'medical', commerce: 'local-shops',
};

export function IndustryImage({ name, alt = '', eager = false, className = '' }: { name: string; alt?: string; eager?: boolean; className?: string }) {
  const image = domainImages[name] ?? name;
  return <img className={`industry-image ${className}`} src={`/images/industries/${image}-960.jpg?v=20261026`}
    srcSet={`/images/industries/${image}-480.jpg?v=20261026 480w, /images/industries/${image}-960.jpg?v=20261026 960w`}
    sizes="(max-width: 700px) calc(100vw - 36px), (max-width: 1100px) 55vw, 640px"
    width="960" height="640" alt={alt} loading={eager ? 'eager' : 'lazy'} decoding="async" />;
}
